import { Component, OnInit } from '@angular/core';
import { GungModalService } from 'gung-standard';
import { ColmecDiscountsService, ImportResponse } from '../../../services/colmec-discounts.service';



@Component({
    selector: 'colmec-discount-import-modal',
    templateUrl: './colmec-discount-import-modal.component.html',
    styleUrls: ['./colmec-discount-import-modal.component.scss'],
    standalone: false
})
export class ColmecDiscountImportModalComponent implements OnInit{

  response: ImportResponse;

  constructor(
    protected colmecDiscountsService: ColmecDiscountsService
  ){
    
  }

  loading = false;
  
  delegate: GungModalService;
  componentId: string;

  ngOnInit(): void {
    this.componentId = ColmecDiscountImportModalComponent.name;
  }

  onFileSelect(event){
    this.loading = true;
    const files: FileList = event.target.files;
    
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i]);
    }
   
    this.colmecDiscountsService.import(formData).subscribe(data => {      
      this.response = data ? data[0] : null;
      this.loading = false;
      this.colmecDiscountsService.updateDiscountListSubject();
    })
  }
  
  confirm() {
    
  }

  cancel() {
    this.delegate.modalRef.get(this.componentId).close({ });
  }
}
